import { render, staticRenderFns } from "./PharmaciesList.vue?vue&type=template&id=2cadf89c&scoped=true&lang=pug"
import script from "./PharmaciesList.vue?vue&type=script&lang=js"
export * from "./PharmaciesList.vue?vue&type=script&lang=js"
import style0 from "./PharmaciesList.vue?vue&type=style&index=0&id=2cadf89c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cadf89c",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Icon: require('/home/docker/code/frontend/components/Icon.vue').default,Address: require('/home/docker/code/frontend/components/Address.vue').default})
